/**
 * Localize Shopify Inbox chat widget UI strings to Latvian.
 * Inbox embed settings only cover greeting/button; core UI stays English without this.
 */
(function () {
  'use strict';

  var TEXT_MAP = {
    'Chat with us': 'Sazinies ar mums',
    'Instant answers': 'Ātrās atbildes',
    'Write message': 'Raksti ziņu',
    Send: 'Sūtīt',
    'Track my order': 'Kur ir mans pasūtījums?',
    Today: 'Šodien',
    Yesterday: 'Vakar',
    Automated: 'Automātiski',
    'You sent:': 'Tu nosūtīji:',
    'Customer Support:': 'AIOO atbalsts:',
    'Sign up for updates': 'Pieteikties jaunumiem',
    'Sign up for email promotions and updates': 'Piesakies e-pasta jaunumiem',
    'Email address': 'E-pasta adrese',
    Email: 'E-pasts',
    Subscribe: 'Pieteikties',
    Skip: 'Izlaist',
    'Maybe later': 'Vēlāk',
    'Leave a message': 'Atstāj ziņu',
    'Type a message': 'Raksti ziņu',
    'Enter your email': 'Ievadi e-pastu',
    'Get updates': 'Saņemt jaunumus',
    Close: 'Aizvērt',
    Minimize: 'Samazināt',
    'Powered by Shopify Inbox': 'Shopify Inbox',
    'Return to chat': 'Atpakaļ uz tērzēšanu',
    'You sent': 'Tu nosūtīji',
    'Customer Support': 'AIOO atbalsts',
    'Start chat': 'Sākt tērzēšanu',
    Continue: 'Turpināt',
    Name: 'Vārds',
    'Phone number': 'Tālrunis',
    'Your name': 'Tavs vārds',
    'Your email': 'Tavs e-pasts',
    Message: 'Ziņa',
    Online: 'Tiešsaistē',
    Offline: 'Bezsaistē',
    'New message': 'Jauna ziņa',
    'We typically reply': 'Parasti atbildam',
    'Thanks for subscribing': 'Paldies par pieteikšanos',
    'Thanks for your message': 'Paldies par ziņu',
    'Add attachment': 'Pievienot pielikumu',
    Attachment: 'Pielikums',
    Upload: 'Augšupielādēt',
    Remove: 'Noņemt',
    Back: 'Atpakaļ',
    Aioostore: 'AIOO',
    'Kā es varu uzzināt sava iphone cenu?': 'Kā es varu uzzināt sava iPhone cenu?'
  };

  var PARTIAL_REPLACEMENTS = [
    [
      'Sign up for email promotions and updates or write a message to start a chat with Aioostore.',
      'Piesakies e-pasta jaunumiem vai raksti ziņu, lai sazinātos ar AIOO.'
    ],
    [
      'Sign up for email promotions and updates or write a message to start a chat.',
      'Piesakies e-pasta jaunumiem vai raksti ziņu, lai sāktu tērzēšanu.'
    ],
    [
      'Sign up for email promotions and updates from Aioostore.',
      'Piesakies e-pasta jaunumiem no AIOO.'
    ],
    ['write a message to start a chat with Aioostore', 'raksti ziņu, lai sazinātos ar AIOO'],
    ['write a message to start a chat', 'raksti ziņu, lai sāktu tērzēšanu'],
    ['Sign up for email promotions and updates', 'Piesakies e-pasta jaunumiem'],
    ['email promotions and updates', 'e-pasta jaunumiem'],
    ['Customer Support', 'AIOO atbalsts'],
    ['start a chat with Aioostore', 'sākt tērzēšanu ar AIOO'],
    ['AIOO on WhatsApp', 'AIOO WhatsApp'],
    [' on WhatsApp', ' WhatsApp'],
    ['Return to chat', 'Atpakaļ uz tērzēšanu']
  ];

  var PARTIAL_REPLACEMENTS_CI = [
    ['sign up for email promotions and updates or write a message to start a chat with aioostore', 'piesakies e-pasta jaunumiem vai raksti ziņu, lai sazinātos ar AIOO'],
    ['sign up for email promotions and updates or write a message to start a chat', 'piesakies e-pasta jaunumiem vai raksti ziņu, lai sāktu tērzēšanu'],
    ['sign up for email promotions and updates from aioostore', 'piesakies e-pasta jaunumiem no AIOO'],
    ['write a message to start a chat with aioostore', 'raksti ziņu, lai sazinātos ar AIOO'],
    ['sign up for email promotions and updates', 'piesakies e-pasta jaunumiem'],
    ['email promotions and updates', 'e-pasta jaunumiem'],
    ['return to chat', 'atpakaļ uz tērzēšanu'],
    ['aioo on whatsapp', 'AIOO WhatsApp'],
    ['or write a message', 'vai raksti ziņu'],
    ['write a message', 'raksti ziņu']
  ];

  var HIDDEN_INSTANT_ANSWERS = [
    'Vai es varu atdot savu iPhone kā pirmo iemaksu?',
    'Kā es varu uzzināt sava iPhone cenu?',
    'Kā es varu uzzināt sava iphone cenu?'
  ];

  var PRIORITY_INSTANT_ANSWER_HINTS = ['piegāde', 'atgriešana', 'garantija'];

  var ARIA_MAP = Object.assign({}, TEXT_MAP, {
    Chat: 'Aizvērt tērzēšanu',
    'Return to chat': 'Atpakaļ uz tērzēšanu',
    'Minimize chat': 'Samazināt tērzēšanu',
    'Close chat': 'Aizvērt tērzēšanu'
  });

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function replaceAllInsensitive(text, needle, replacement) {
    if (!needle) return text;
    return text.replace(new RegExp(escapeRegExp(needle), 'gi'), replacement);
  }

  function applyReplacements(text, map, partials) {
    if (!text) return text;
    var out = text;
    Object.keys(map).forEach(function (key) {
      if (out.indexOf(key) !== -1) out = out.split(key).join(map[key]);
    });
    partials.forEach(function (pair) {
      if (out.indexOf(pair[0]) !== -1) out = out.split(pair[0]).join(pair[1]);
    });
    PARTIAL_REPLACEMENTS_CI.forEach(function (pair) {
      out = replaceAllInsensitive(out, pair[0], pair[1]);
    });
    return out;
  }

  function localizeTextContent(text) {
    return applyReplacements(text, TEXT_MAP, PARTIAL_REPLACEMENTS);
  }

  function localizeTextNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentElement;
      if (!parent || parent.tagName === 'SCRIPT' || parent.tagName === 'STYLE') continue;
      var original = node.textContent;
      if (!original || !original.trim()) continue;
      var mapped = localizeTextContent(original);
      if (mapped !== original) node.textContent = mapped;
    }
  }

  function localizeAttributes(root) {
    root.querySelectorAll('[placeholder], [aria-label], [value], [title]').forEach(function (el) {
      ['placeholder', 'aria-label', 'value', 'title'].forEach(function (attr) {
        var current = el.getAttribute(attr);
        if (!current) return;
        var map = attr === 'aria-label' ? ARIA_MAP : TEXT_MAP;
        var next = applyReplacements(current, map, PARTIAL_REPLACEMENTS);
        if (next !== current) el.setAttribute(attr, next);
      });
    });
  }

  function trimInstantAnswers(root) {
    root.querySelectorAll('.instant-answers-list__prompt').forEach(function (btn) {
      var label = btn.querySelector('p');
      var text = (label && label.textContent || '').trim();
      btn.hidden = HIDDEN_INSTANT_ANSWERS.indexOf(text) !== -1;
    });
  }

  function reorderInstantAnswers(root) {
    var list = root.querySelector('.instant-answers-list');
    if (!list || list.__aiooReordered) return;

    var prompts = Array.prototype.slice.call(
      list.querySelectorAll('.instant-answers-list__prompt')
    );
    if (!prompts.length) return;

    var prioritized = [];
    var rest = [];

    prompts.forEach(function (btn) {
      var text = ((btn.querySelector('p') || {}).textContent || '').toLowerCase();
      var rank = -1;
      PRIORITY_INSTANT_ANSWER_HINTS.forEach(function (hint, index) {
        if (rank === -1 && text.indexOf(hint) !== -1) rank = index;
      });
      if (rank !== -1) prioritized.push({ btn: btn, rank: rank });
      else rest.push(btn);
    });

    if (!prioritized.length) return;

    prioritized.sort(function (a, b) {
      return a.rank - b.rank;
    });

    prioritized.forEach(function (item) {
      list.appendChild(item.btn);
    });
    rest.forEach(function (btn) {
      list.appendChild(btn);
    });

    list.__aiooReordered = true;
  }

  var attachedHosts = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function localizeRoot(root) {
    if (!root) return;
    localizeTextNodes(root);
    localizeAttributes(root);
    trimInstantAnswers(root);
    reorderInstantAnswers(root);
  }

  function attach(host) {
    if (!host || host.__aiooInboxLv) return;
    if (attachedHosts && attachedHosts.has(host)) return;
    host.__aiooInboxLv = true;
    if (attachedHosts) attachedHosts.set(host, true);

    var isLocalizing = false;
    var pending = null;
    var shadowObserver = null;

    function doLocalize() {
      if (!host.shadowRoot || isLocalizing) return;
      isLocalizing = true;
      if (shadowObserver) shadowObserver.disconnect();
      try {
        localizeRoot(host.shadowRoot);
      } finally {
        isLocalizing = false;
        if (shadowObserver && host.shadowRoot) {
          shadowObserver.observe(host.shadowRoot, { childList: true, subtree: true });
        }
      }
    }

    function scheduleLocalize() {
      if (isLocalizing) return;
      if (pending !== null) return;
      pending = requestAnimationFrame(function () {
        pending = null;
        doLocalize();
      });
    }

    function observeShadow() {
      if (!host.shadowRoot) return;
      doLocalize();
      shadowObserver = new MutationObserver(scheduleLocalize);
      shadowObserver.observe(host.shadowRoot, { childList: true, subtree: true });
    }

    if (host.shadowRoot) {
      observeShadow();
      return;
    }

    new MutationObserver(function (_, observer) {
      if (!host.shadowRoot) return;
      observer.disconnect();
      observeShadow();
    }).observe(host, { childList: true });
  }

  function boot() {
    document.querySelectorAll('inbox-online-store-chat').forEach(attach);

    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'INBOX-ONLINE-STORE-CHAT') attach(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('inbox-online-store-chat').forEach(attach);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
